import { StateToken } from '@ngxs/store';
import { IDocumentCountersignState } from './document-countersign.state';

export const DOCUMENT_COUNTERSIGN_STATE_TOKEN = new StateToken<IDocumentCountersignState>('documentCountersign');
